// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"b3ca9813","340":"cf1f4f57"}[chunkId] + ".chunk.css";
};